module.exports = __webpack_public_path__ + "img/draw_temuout2.e090179c.png";